<template>
    <b-button variant="link" :to="to">
        <fa class="mr-1" icon="chevron-left" :title="label ? null : $t('Back')"/>
        <template v-if="label">{{ label }}</template>
    </b-button>
</template>

<script>
    export default {
        name: 'BackButton',
        props: {
            to: {
                type: [String, Object],
                default: null,
            },
            label: {
                type: String,
                default: null
            }
        },
    };
</script>
